import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconButton } from '@openx/design-system/components/Button/IconButton';
import { List, Minus, X } from '@phosphor-icons/react';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { OpenXAgentEditIcon } from '../icons/OpenXAgentEditIcon';
import { OpenXAgentIcon } from '../icons/OpenXAgentIcon';
import { getNavbarIconStyles, getNavbarStyles } from './OpenXAgentNavbar.styles';

type OpenXAgentNavbarProps = {
  isDragging?: boolean;
  onDragStart?: (event: MouseEvent<HTMLDivElement>) => void;
  onClose?: () => void;
  onMinimize?: () => void;
  onMenuClick?: (() => void) | undefined;
  title?: string;
  /** when provided, renders the edit button that returns the user to the Home View */
  onEditClick?: () => void;
};

export const OpenXAgentNavbar = ({
  isDragging = false,
  onDragStart,
  onClose,
  onMinimize,
  onMenuClick,
  title,
  onEditClick,
}: OpenXAgentNavbarProps) => {
  const { t } = useTranslation();

  return (
    <Box onMouseDown={onDragStart} sx={getNavbarStyles(isDragging)}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <IconButton aria-label="OpenX Agent menu" color="secondary" onClick={onMenuClick}>
          <List />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            gap: 0.75,
          }}
        >
          <Box sx={getNavbarIconStyles}>
            <OpenXAgentIcon width={16} height={16} />
          </Box>

          <Typography
            variant="h2"
            sx={{
              fontWeight: 'fontWeightBold',
              color: 'text.primary',
            }}
          >
            {title ?? t('OpenX Agent')}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {onEditClick ? (
          <IconButton aria-label={t('Back to OpenX Agent home')} color="secondary" onClick={onEditClick}>
            <OpenXAgentEditIcon />
          </IconButton>
        ) : null}

        <IconButton aria-label="OpenX Agent minimize" color="secondary" onClick={onMinimize}>
          <Minus />
        </IconButton>

        <IconButton aria-label="OpenX Agent close" color="secondary" onClick={onClose}>
          <X />
        </IconButton>
      </Box>
    </Box>
  );
};
